angular.module("vgresiduos").component("residueReportNoData", {
	controller: function () {},
	templateUrl: "views/report/residue/base/residueReportNoData/residueReportNoData_template.html",
	bindings: {
		text: "@"
	}
});
